import React from 'react';
import './style.css';

const successIcon = (
  <svg width="72" height="72" viewBox="0 0 72 72" fill="none" aria-hidden="true">
    <circle cx="36" cy="36" r="36" fill="#E7F6EC" />
    <path d="M22 37.5l9 9L50 26" stroke="#2F9E44" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const failIcon = (
  <svg width="72" height="72" viewBox="0 0 72 72" fill="none" aria-hidden="true">
    <circle cx="36" cy="36" r="36" fill="#FDECEC" />
    <path d="M36 22v18" stroke="#E03131" strokeWidth="4" strokeLinecap="round" />
    <circle cx="36" cy="48" r="2.5" fill="#E03131" />
  </svg>
);

const BOUQUET_REFRESH_STATUS = {
  success: {
    icon: successIcon,
    title: 'Bouquet Refresh Successful',
    message: 'The bouquet has been refreshed successfully for this subscriber.',
  },
  fail: {
    icon: failIcon,
    title: 'Bouquet Refresh Failed',
    message: "We couldn't refresh the bouquet for this subscriber at the moment. Please try again.",
  },
};

function BouquetRefreshModal(props) {
  const { closePopup, modalParameters } = props;
  const result = BOUQUET_REFRESH_STATUS[modalParameters && modalParameters.status] || BOUQUET_REFRESH_STATUS.fail;

  return (
    <div id="Bouquet-refresh-modal">
        <div className="bouquet-icon">{result.icon}</div>
        <div className="bouquet-heading">{result.title}</div>
        <div className="bouquet-subHeading">{result.message}</div>
        <button type="button" className="bouquet-ok-btn" onClick={closePopup}>
          <span>OK</span>
        </button>
    </div>
  );
}

export default BouquetRefreshModal;
